module.exports = __webpack_public_path__ + "static/img/bg.acc4ecc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = dZ/S
// module chunks = 0